/**
 * Carte « Découvre la feuille de brouillon » des tableaux de bord : mène à
 * l'exercice tutoriel tant qu'il n'a pas été fait sur cet appareil.
 */

import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { PencilLine, Play } from 'lucide-react';
import { hasDoneScratchTutorial } from './tutorial';

export function ScratchTutorialCard() {
  const [done] = useState(hasDoneScratchTutorial);
  if (done) return null;
  return (
    <section
      aria-labelledby="scratch-tutorial-title"
      className="border-primary-200 bg-primary-50/60 ocean:bg-white/5 flex items-center gap-3 rounded-2xl border p-4"
      data-testid="scratch-tutorial-card"
    >
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <span className="bg-primary-500 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-white">
          <PencilLine className="h-5 w-5" aria-hidden />
        </span>
        <div className="min-w-0">
          <h2 id="scratch-tutorial-title" className="font-display text-ink-900 text-base font-bold">
            Découvre la feuille de brouillon
          </h2>
          <p className="text-ink-600 text-sm">
            Un exercice guidé d’une minute pour apprendre à écrire tes calculs et à répondre.
          </p>
        </div>
      </div>
      <Link
        to="/brouillon/tutoriel"
        aria-label="Faire le tutoriel de la feuille de brouillon"
        title="Faire le tutoriel"
        className="bg-primary-500 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white shadow-md hover:brightness-95 active:scale-[0.95]"
      >
        <Play className="ml-0.5 h-5 w-5 fill-current" aria-hidden />
      </Link>
    </section>
  );
}
